import { BannerPromo } from "../entities/BannerPromo";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}banners`;

export const fetchBannerPromo = async (): Promise<BannerPromo[]> => {
  const response = await axios.get(API_URL); // Use axios to make the GET request.
  const data = response.data.data; // Access the nested 'data' array.
  
  // Map the response to BannerPromo instances.
  return data.map((item: any) => new BannerPromo(item.id, item.name, item.path, item.path_apps, item.is_active));
};